// FIREBASE CONFIGURATION
// Firebase project: onion-trading-system

export const firebaseConfig = {
  apiKey: "AIzaSyByB7Jz377bAStilAwP-jF62QQmAxrjmBE",
  authDomain: "onion-trading-system.firebaseapp.com",
  projectId: "onion-trading-system",
  storageBucket: "onion-trading-system.firebasestorage.app",
  messagingSenderId: "631339725213",
  appId: "1:631339725213:web:2c67bfd221d560d77c7f74",
  measurementId: "G-0KV1TJS8M5"
};

// NEXT STEPS:
// 1. Enable Authentication (Email/Password provider) in Firebase Console
// 2. Create Firestore Database in Firebase Console
// 3. Deploy Firestore security rules: firebase deploy --only firestore:rules
// 4. Deploy indexes: firebase deploy --only firestore:indexes
